import React, { useEffect, useState } from 'react';
import { X, Home, Plus } from "lucide-react";
import authService from '../../../Services/authService';
import AddAddressForm from './AddAddressForm';

export default function AddressModal({ isOpen, onClose, refreshAddressList }) {
  const [addresses, setAddresses] = useState([]);
  const [view, setView] = useState("list");
  const token = authService.getCurrentUsertoken();

  useEffect(() => {
    if (isOpen) {
      fetchAddressList();
    }
  }, [isOpen]);

  const fetchAddressList = () => {
    fetch(authService.getApiUrl() + 'Addresslist', {
      method: 'POST',
      body: JSON.stringify({ user_id: authService.getCurrentuser().id }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (res.status === 401) {
          authService.clientlogout();
          window.location.href = "/login";
        }
        return res.json();
      })
      .then((result) => {
        const addressData = result.data.map((item) => ({
          id: item.id,
          flatNumber: item.building_name,
          area: item.area,
          landmark: item.landmark,
          state: item.state_name,
          city: item.city_name,
          phoneNumber: item.phone_number,
          pincode: item.pincode,
          isDefault: result.default_address?.id === item.id,
        }));
        setAddresses(addressData);
      })
      .catch((err) => console.error("Address fetch error:", err.message));
  };

  const handleSelectAddress = (address) => {
    fetch(authService.getApiUrl() + 'updateaddress', {
      method: 'POST',
      body: JSON.stringify({
        user_id: authService.getCurrentuser().id,
        address_id: address.id,
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then(() => {
        refreshAddressList();
        onClose();
      })
      .catch((err) => console.log(err.message));
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-auto">
        <div className="flex justify-between items-center p-4 border-b border-gray-200">
          <h2 className="text-lg font-medium text-gray-800">
            {view === "list" ? "Select Address" : "Add New Address"}
          </h2>
          <button onClick={onClose} className="text-gray-600 hover:text-red-600">
            <X size={20} />
          </button>
        </div>

        <div className="p-4">
          {view === "list" ? (
            <div>
              {addresses.length > 0 ? (
                <div className="space-y-3">
                  {addresses.map((address) => (
                    <div
                      key={address.id}
                      className="border border-gray-200 rounded-lg p-4 cursor-pointer hover:border-red-500/50"
                      onClick={() => handleSelectAddress(address)}
                    >
                      <div className="flex items-start">
                        <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center mr-3 flex-shrink-0">
                          <Home size={16} className="text-red-600" />
                        </div>
                        <div>
                          <div className="flex items-center">
                            <h3 className="text-base font-medium text-gray-800">{address.flatNumber}</h3>
                            {address.isDefault && (
                              <span className="ml-2 text-xs bg-red-100 text-red-600 px-2 py-0.5 rounded">
                                Default
                              </span>
                            )}
                          </div>
                          <p className="text-sm text-gray-600 mt-1">
                            {address.area}, {address.landmark}, {address.city}, {address.state} - {address.pincode}
                          </p>
                          <p className="text-sm text-gray-600 mt-1">Phone: {address.phoneNumber}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-8">
                  <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
                    <Home size={24} className="text-red-600" />
                  </div>
                  <h3 className="text-lg font-medium text-gray-800 mb-2">No addresses found</h3>
                  <p className="text-sm text-gray-600 mb-4">Add a new address to continue</p>
                </div>
              )}
              <button
                onClick={() => setView("add")}
                className="mt-4 w-full flex items-center justify-center px-4 py-3 border border-red-600 text-red-600 rounded-md"
              >
                <Plus size={18} className="mr-2" />
                Add New Address
              </button>
            </div>
          ) : (
            <AddAddressForm
              onBack={() => setView("list")}
              onSuccess={() => {
                fetchAddressList();
                setView("list");
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
